export const siteSettings = {
  name: "Worldwide Trade Hub",
  link: "https://worldwidetradeshub.com",
  email: "support@worldwidetradeshub.com",
  appLink: "https://app.worldwidetradeshub.com",
};
